import { createPortal } from "react-dom";

export default function ToastContainer({ isClient, toasts, onRemoveToast }) {
  if (!isClient || toasts.length === 0) {
    return null;
  }
  return createPortal(
    <div className="fixed bottom-6 right-6 z-50 flex w-full max-w-sm flex-col gap-3 px-4 sm:px-0">
      {toasts.map((toast) => {
        const tone =
          toast.type === "success"
            ? "border-emerald-200 bg-emerald-50 text-emerald-700"
            : toast.type === "info"
              ? "border-slate-200 bg-white text-slate-700"
              : "border-red-200 bg-red-50 text-red-700";
        return (
          <div
            key={toast.id}
            className={`flex items-start justify-between gap-3 rounded-xl border px-4 py-3 shadow-sm ${tone}`}
          >
            <div className="text-sm font-medium">{toast.message}</div>
            <button
              type="button"
              onClick={() => onRemoveToast(toast.id)}
              className="text-xs font-semibold uppercase tracking-wide text-slate-500 transition hover:text-slate-700"
            >
              Close
            </button>
          </div>
        );
      })}
    </div>,
    document.body
  );
}
